import { render, staticRenderFns } from "./BookComponentListItem.vue?vue&type=template&id=1bef2a00&"
import script from "./BookComponentListItem.vue?vue&type=script&lang=ts&"
export * from "./BookComponentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./BookComponentListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\2-Projects\\1-asva\\5-vue-book\\1-vue-book\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1bef2a00', component.options)
    } else {
      api.reload('1bef2a00', component.options)
    }
    module.hot.accept("./BookComponentListItem.vue?vue&type=template&id=1bef2a00&", function () {
      api.rerender('1bef2a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\components\\FileTree\\BookComponentListItem.vue"
export default component.exports